export default [
  { pathname: '/joy-ui/api/accordion' },
  { pathname: '/joy-ui/api/accordion-details' },
  { pathname: '/joy-ui/api/accordion-group' },
  { pathname: '/joy-ui/api/accordion-summary' },
  { pathname: '/joy-ui/api/alert' },
  { pathname: '/joy-ui/api/aspect-ratio' },
  { pathname: '/joy-ui/api/autocomplete' },
  { pathname: '/joy-ui/api/autocomplete-listbox' },
  { pathname: '/joy-ui/api/autocomplete-option' },
  { pathname: '/joy-ui/api/avatar' },
  { pathname: '/joy-ui/api/avatar-group' },
  { pathname: '/joy-ui/api/badge' },
  { pathname: '/joy-ui/api/box' },
  { pathname: '/joy-ui/api/breadcrumbs' },
  { pathname: '/joy-ui/api/button' },
  { pathname: '/joy-ui/api/button-group' },
  { pathname: '/joy-ui/api/card' },
  { pathname: '/joy-ui/api/card-actions' },
  { pathname: '/joy-ui/api/card-content' },
  { pathname: '/joy-ui/api/card-cover' },
  { pathname: '/joy-ui/api/card-overflow' },
  { pathname: '/joy-ui/api/checkbox' },
  { pathname: '/joy-ui/api/chip' },
  { pathname: '/joy-ui/api/chip-delete' },
  { pathname: '/joy-ui/api/circular-progress' },
  { pathname: '/joy-ui/api/css-baseline' },
  { pathname: '/joy-ui/api/dialog-actions' },
  { pathname: '/joy-ui/api/dialog-content' },
  { pathname: '/joy-ui/api/dialog-title' },
  { pathname: '/joy-ui/api/divider' },
  { pathname: '/joy-ui/api/drawer' },
  { pathname: '/joy-ui/api/form-control' },
  { pathname: '/joy-ui/api/form-helper-text' },
  { pathname: '/joy-ui/api/form-label' },
  { pathname: '/joy-ui/api/grid' },
  { pathname: '/joy-ui/api/icon-button' },
  { pathname: '/joy-ui/api/input' },
  { pathname: '/joy-ui/api/linear-progress' },
  { pathname: '/joy-ui/api/link' },
  { pathname: '/joy-ui/api/list' },
  { pathname: '/joy-ui/api/list-divider' },
  { pathname: '/joy-ui/api/list-item' },
  { pathname: '/joy-ui/api/list-item-button' },
  { pathname: '/joy-ui/api/list-item-content' },
  { pathname: '/joy-ui/api/list-item-decorator' },
  { pathname: '/joy-ui/api/list-subheader' },
  { pathname: '/joy-ui/api/menu' },
  { pathname: '/joy-ui/api/menu-button' },
  { pathname: '/joy-ui/api/menu-item' },
  { pathname: '/joy-ui/api/menu-list' },
  { pathname: '/joy-ui/api/modal' },
  { pathname: '/joy-ui/api/modal-close' },
  { pathname: '/joy-ui/api/modal-dialog' },
  { pathname: '/joy-ui/api/modal-overflow' },
  { pathname: '/joy-ui/api/option' },
  { pathname: '/joy-ui/api/radio' },
  { pathname: '/joy-ui/api/radio-group' },
  { pathname: '/joy-ui/api/scoped-css-baseline' },
  { pathname: '/joy-ui/api/select' },
  { pathname: '/joy-ui/api/sheet' },
  { pathname: '/joy-ui/api/skeleton' },
  { pathname: '/joy-ui/api/slider' },
  { pathname: '/joy-ui/api/snackbar' },
  { pathname: '/joy-ui/api/stack' },
  { pathname: '/joy-ui/api/step' },
  { pathname: '/joy-ui/api/step-button' },
  { pathname: '/joy-ui/api/step-indicator' },
  { pathname: '/joy-ui/api/stepper' },
  { pathname: '/joy-ui/api/svg-icon' },
  { pathname: '/joy-ui/api/switch' },
  { pathname: '/joy-ui/api/tab' },
  { pathname: '/joy-ui/api/table' },
  { pathname: '/joy-ui/api/tab-list' },
  { pathname: '/joy-ui/api/tab-panel' },
  { pathname: '/joy-ui/api/tabs' },
  { pathname: '/joy-ui/api/textarea' },
  { pathname: '/joy-ui/api/toggle-button-group' },
  { pathname: '/joy-ui/api/tooltip' },
  { pathname: '/joy-ui/api/typography' },
];
